module.exports = __webpack_public_path__ + "02_very_short_brown.959cbedc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/02_very_short_brown.png
// module id = vV69
// module chunks = 0